import { ApiService } from 'services';

import { GET_ONLINE_CONFIG_FAILURE, getOnlineConfig } from 'actions';
import { history } from 'containers/App';

export const SITE_PRELOAD_REQUEST = 'SITE_PRELOAD_REQUEST';
export const SITE_PRELOAD_SUCCESS = 'SITE_PRELOAD_SUCCESS';
export const SITE_PRELOAD_FAILED = 'SITE_PRELOAD_FAILED';

function request() {
  return {
    type: SITE_PRELOAD_REQUEST
  };
}

function receive() {
  return {
    type: SITE_PRELOAD_SUCCESS,
  };
}

function failed() {
  return {
    type: GET_ONLINE_CONFIG_FAILURE,
  };
}

export function getSitePreload(json) {
  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService.getDspConsole(json.url, json.headers)
      .then((response) => {
        if (json.success.includes(response.status)) {
          dispatch(receive());
          dispatch(getOnlineConfig());
        } else {
          history.push('/unauthorized');
          dispatch(failed());
        }
      }).catch(() => {
        history.push('/unauthorized');
        dispatch(failed());
      });
    return promise();
  };
}
